// shop-the look

function waitForElem(
  waitFor,
  callback,
  minElements = 1,
  isVariable = false,
  timer = 10000,
  frequency = 25,
) {
  let elements = isVariable
    ? window[waitFor]
    : document.querySelectorAll(waitFor);
  if (timer <= 0) return;
  (!isVariable && elements.length >= minElements) ||
    (isVariable && typeof window[waitFor] !== "undefined")
    ? callback(elements)
    : setTimeout(
      () =>
        waitForElem(
          waitFor,
          callback,
          minElements,
          isVariable,
          timer - frequency,
        ),
      frequency,
    );
}

const OpenShopTheLookModal = () => {
  document
    .querySelector(".shop-the-look-modal-overlay")
    .classList.add("is-open");
  document.body.style.overflow = "hidden";
};
const CloseShopTheLookModal = () => {
  document
    .querySelector(".shop-the-look-modal-overlay")
    .classList.remove("is-open");
  document.body.style.overflow = "auto";
};
document.body?.addEventListener("click", (e) => {
  if (
    e.target == document.querySelector(".shop-the-look-modal-overlay") ||
    e.target.closest(".shop-the-look-modal-wrapper .close-icon")
  ) {
    CloseShopTheLookModal();
  }
});
waitForElem(
  ".shop-the-look-modal-content .product-details #product-variants .size ul li",
  () => {
    document
      .querySelectorAll(".shop-the-look-modal-wrapper button[type='submit']")
      .forEach((button) => {
        button?.addEventListener("click", () => {
          setTimeout(() => {
            juno.checkToggleBasketNavigation();
          }, 1200);
        });
      });
    document
      .querySelectorAll(
        ".shop-the-look-modal-content .product-details #product-variants .size ul li.active",
      )
      .forEach((item) => {
        item?.addEventListener("click", () => {
          const data_size = item.getAttribute("data-size") || "";
          item.closest(".size").querySelector("label").dataset.size = data_size;
          item.closest(".size").querySelector("label span").textContent =
            `Size: ${data_size}`;
          const itemId = item.getAttribute("data-id");
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(".item form input[id='atc-product-id']").value =
            itemId;
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(".item form button[type='submit']")
            .classList.remove("disable-atc");
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(".item form button[type='submit']").textContent =
            "Add to Bag";
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(
              ".product-details #product-variants .size .product-option-size",
            )
            .classList.remove("active");
        });
      });
    document
      .querySelectorAll(
        ".shop-the-look-modal-content .product-details #product-variants .size label",
      )
      .forEach((item) => {
        item?.addEventListener("click", () => {
          item
            .closest(".shop-the-look-modal-content .item")
            .querySelector(
              ".product-details #product-variants .size .product-option-size",
            )
            .classList.toggle("active");
        });
      });
  },
);
waitForElem(
  ".shop-the-look-modal-content #styledWith .blockHeader",
  ([heading]) => {
    heading.textContent = "SHOP THE LOOK";
  },
);

// shop-the look

// sticky-atc-bar
const stickyBar = document.getElementById("sticky-atc-bar");
if (stickyBar) {
  const mainForm = document.getElementById("ValidAddtoCart");
  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        // Check if the form is completely above the viewport (scrolled past)
        const isAboveViewport = entry.boundingClientRect.bottom < 0;
        stickyBar.classList.toggle("visible", isAboveViewport);
      });
    },
    { threshold: 0 }, // fire when any part enters or leaves the viewport
  );
  if (mainForm) observer.observe(mainForm);
}
// sticky-atc-bar

/* Back in Stock Modal Events */
var backInStockButton = document.querySelector("[data-modal-trigger]");
var backInStockModal = document.querySelector("[data-back-in-stock-modal]");
if (backInStockButton && backInStockModal) {
  backInStockButton?.addEventListener("click", function () {
    backInStockModal.classList.toggle("active");
  });
  backInStockModal
    .querySelectorAll("[data-close-modal-trigger]")
    .forEach(function (el) {
      el?.addEventListener("click", function () {
        backInStockModal.classList.remove("active");
      });
    });
}

/* Back in Stock Form */
if (backInStockButton && backInStockModal) {
  var selectors = {
    form: "[data-back-in-stock-form]",
    emailInput: "[data-back-in-stock-email]",
    errorMessage: "[data-back-in-stock-error]",
    productInput: "[data-back-in-stock-product]",
    submitButton: "[data-back-in-stock-submit]",
    successView: "[data-back-in-stock-success-view]",
    successMessage: "[data-back-in-stock-success]",
    variantInput: "[data-back-in-stock-variant]",
  };
  var form = document.querySelector(selectors.form);
  var emailInput = document.querySelector(selectors.emailInput);
  var errorMessageContainer = document.querySelector(selectors.errorMessage);
  var productInput = document.querySelector(selectors.productInput);
  var submitButton = document.querySelector(selectors.submitButton);
  var successMessageContainer = document.querySelector(
    selectors.successMessage,
  );
  var successView = document.querySelector(selectors.successView);
  var variantInput = document.querySelector(selectors.variantInput);

  function onSubmit(event) {
    event.preventDefault();
    if (!emailInput.value || emailInput.value.length === 0) {
      errorMessageContainer.textContent = "Please enter an email address";
      return;
    }
    if (variantInput.value && productInput.value) {
      submitButton.disabled = true;
      errorMessageContainer.textContent = "";
      const payload = {
        data: {
          type: "back-in-stock-subscription",
          attributes: {
            profile: {
              data: {
                type: "profile",
                attributes: { email: emailInput.value },
              },
            },
            channels: ["EMAIL"],
          },
          relationships: {
            variant: {
              data: {
                type: "catalog-variant",
                id: `$shopify:::$default:::${variantInput.value}`,
              },
            },
          },
        },
      };
      fetch(
        "https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=W9kQzw",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            revision: "2024-06-15",
          },
          body: JSON.stringify(payload),
        },
      )
        .then((result) => {
          if (result.status == 202) {
            successMessageContainer.textContent = `Thank you, We'll notify you when it's back in stock.`;
            successView.classList.toggle("u-hide");
          } else {
            errorMessageContainer.textContent =
              "Something went wrong. Please try again in a moment.";
          }
        })
        .catch(() => {
          errorMessageContainer.textContent =
            "Something went wrong. Please try again in a moment.";
        });
    }
  }
  form?.addEventListener("submit", onSubmit);
}
/* Back in Stock Modal Events */

